/**
 * Font stacks shared across the readiness view components.
 * Pulled out so a single import gives any sub-component the three families
 * without duplicating the string literals.
 */

export const monoFont = "'JetBrains Mono', monospace";
export const sansFont = "'Geist', sans-serif";
export const serifFont = "'Instrument Serif', serif";
